import { DeliveryStatus } from "../constants";

export const canUpdateDelivery = (deliveryStatus: number) => deliveryStatus === DeliveryStatus.Packaging;
